module.exports = __webpack_public_path__ + "assets/images/869168709b2757c765d48756f7b3c6aa-walk-behind-tractor.png";